import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-om5",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-om5.component.html",
  styleUrl: "./prefix-om5.component.less",
})
export class PrefixOm5Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 100;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["om5"];
  }
}
